<template>
  <CModal alignment="center" :visible="show" @close="$emit('close')">
    <CModalHeader class="bg-primary">
      <CModalTitle class="text-light fs-6">刪除</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <p>確定要刪除此筆資訊？</p>
      <p>如點選確定,此筆資訊將永久刪除。</p>
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" @click="$emit('confirm')">確定</CButton>
      <CButton color="secondary" variant="outline" @click="$emit('close')"
        >取消</CButton
      >
    </CModalFooter>
  </CModal>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: undefined,
    },
  },
  emits: ['close', 'confirm'],
}
</script>
<style lang="scss" scoped>
img {
  width: 15px;
  margin: 0 10px;
}
.content {
  background-color: #fff;
  border: 1px solid #bdbdbd;
  outline: none;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.options-box {
  height: 300px;
  overflow: scroll;
}
</style>
